import { Slider } from "@components/atoms/Slider"
import { BlogPostTile } from "@components/news/BlogPostTile"
import { LargeBlogTile } from "@components/news/LargeBlogTile"
import { Button } from "@components/ui/Button"
import { Chip } from "@components/ui/Chip"
import { BlogPostQuery, BlogTileFragment } from "@generated-types"
import { defineBlock, EditableText } from "eddev/blocks"

type Props = {
  currentSlug?: string
  posts?: BlogTileFragment[]
}

export function BlogRelated(props: Props) {
  const posts = (props.posts || []).filter((p) => p.uri !== props.currentSlug).slice(0, 3)

  if (posts.length === 0) {
    return null
  }

  if (props.posts?.length === 1) {
    return (
      <div>
        <div className="w-grid mx-auto">
          <LargeBlogTile {...props.posts[0]!} />
        </div>
      </div>
    )
  }

  return (
    <div data-mixpanel-block="Latest News">
      <div className="w-grid mx-auto flex justify-between items-center mb-4">
        <div className="col-span-9 flex items-center gap-4">
          <h2 className="type-title-m">Related News</h2>
          {posts[0].info?.category?.name && (
            <Chip shape="rounded" variant="mid">
              {posts[0].info?.category?.name}
            </Chip>
          )}
        </div>
        <div className="col-span-3 flex items-end">
          <Button href={`/blog/?category=${posts[0].info?.category?.slug}`} variant="default" rightIcon="chevronRight">
            See all
          </Button>
        </div>
      </div>
      <Slider arrows gridInsert scrollerClass="flex gap-grid-gutter px-grid-margin-full">
        {posts?.map((post) => (
          <div className="flex-none w-cols-8 md:w-cols-4 py-[10px]" key={post?.uri}>
            <BlogPostTile {...post!} />
          </div>
        ))}
      </Slider>
    </div>
  )
}
